import { Component, OnInit } from '@angular/core';
import { DetalleCajaService, DetalleVentaService } from 'src/app/service/index.service';
import * as moment from 'moment';

@Component({
  selector: 'app-reporte-ventas-fecha',
  templateUrl: './reporte-ventas-fecha.component.html',
  styleUrls: ['./reporte-ventas-fecha.component.css']
})
export class ReporteVentasFechaComponent implements OnInit {
  fechade: any;
  fechaha: any;
  items: any;
  ganancia: any;
  loading = false

  fecha = new Date();
  constructor(private wsdl: DetalleVentaService) { }

  ngOnInit() {
  }
  parseDate(fecha) {
    if (moment(fecha).isValid()) {
      return moment(fecha);
    }
  }
  useFecha: boolean = true;

  get totalVentas() {
    if (!this.items) return 0;
    return Object.values(this.items).reduce((sum: number, v: any) => sum + (Number(v) || 0), 0);
  }

  get totalGanancia() {
    if (!this.ganancia) return 0;
    return Object.values(this.ganancia).reduce((sum: number, v: any) => sum + (Number(v) || 0), 0);
  }

  async getList() {
    try {
      this.loading = true
      this.fechade = moment(this.fechade).format("YYYY-MM-DD") + " 00:00:00";
      this.fechaha = moment(this.fechaha).format("YYYY-MM-DD") + " 23:59:00";

      let data = await this.wsdl.getVentasByFecha(this.fechade, this.fechaha).then();
      let res = JSON.parse(JSON.stringify(data));
      if (res.code == 200) {
        this.items = res.data;
        this.ganancia = res.ganancia;
      }
    } catch (error) {

    } finally {
      this.loading = false

    }
  }
  exportTableToExcel(tableID: string, filename = 'excel_data.xlsx') {
    const dataType = 'application/vnd.ms-excel';

    const tableSelect = document.getElementById(tableID);
    if (!tableSelect) {
      console.error(`Tabla con ID '${tableID}' no encontrada`);
      return;
    }

    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Crear nombre de archivo
    filename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;

    const nav = window.navigator as any;

    if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
      // IE11 o Edge Legacy
      const blob = new Blob(['\ufeff', tableHTML], { type: dataType });
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      // Navegadores modernos
      const downloadLink = document.createElement("a");
      downloadLink.href = `data:${dataType},${tableHTML}`;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }


}
